import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  portfolioPB: number;
  portfolioName: string;
  marketPB: number;
  marketName: string;
}

const keys = ['portfolio', 'market'];

const PBRatioGauge = ({
  portfolioPB,
  portfolioName,
  marketPB,
  marketName,
}: Props) => {
  const entities = {
    [keys[0]]: portfolioPB,
    [keys[1]]: marketPB,
  };
  const entityTitles = {
    [keys[0]]: portfolioName,
    [keys[1]]: marketName,
  };
  return (
    <Gauge
      title="PB Ratio"
      keys={keys}
      entityTitles={entityTitles}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={5}
      from={0}
      to={20}
      flip={true}
    />
  );
};

export default PBRatioGauge;
